import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { Section, SectionTitle, Reveal } from "../components/UIBits";
import { LOGO_URL } from "../lib/constants";
import { useT } from "../lib/i18n";
import api from "../lib/api";

export default function NewsPage() {
    const { t, lang } = useT();
    const [news, setNews] = useState([]);
    useEffect(() => { api.get("/news").then(r => setNews(r.data)); }, []);
    return (
        <div data-testid="news-page">
            <Helmet><title>{`${t("news.title_pre")} ${t("news.title_accent")} — Défi Ultime`}</title></Helmet>
            <Section>
                <SectionTitle kicker={t("news.kicker")} title={t("news.title_pre")} accent={t("news.title_accent")} />
                {news.length === 0 ? (
                    <div className="text-white/50">{t("news.no_news")}</div>
                ) : (
                    <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
                        {news.map((n, i) => (
                            <Reveal key={n.id} delay={i * 0.05}>
                                <Link to={`/nouvelles/${n.id}`} className="block glass-card overflow-hidden h-full hover:border-[#7FD93C] transition-colors" data-testid={`news-card-${n.id}`}>
                                    {n.image_base64 ? (
                                        <img src={n.image_base64} alt={n.title} className="w-full h-48 object-cover" style={{ objectPosition: `50% ${n.image_focal_y ?? 50}%` }} />
                                    ) : (
                                        <div className="w-full h-48 diag-stripes bg-[#121212] flex items-center justify-center">
                                            <img src={LOGO_URL} alt="" className="h-20 w-20 opacity-40" />
                                        </div>
                                    )}
                                    <div className="p-5">
                                        <div className="label-mini mb-2">{new Date(n.created_at).toLocaleDateString(lang === "en" ? "en-CA" : "fr-CA")}</div>
                                        <h3 className="font-display text-2xl uppercase tracking-wide mb-2">{n.title}</h3>
                                        <p className="text-sm text-white/60 line-clamp-3">{n.content}</p>
                                    </div>
                                </Link>
                            </Reveal>
                        ))}
                    </div>
                )}
            </Section>
        </div>
    );
}
